import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { EfaactDataService } from '../../efaact.data-service';
import { ServiceItemHistory } from './service-item-history.model';

export const entityName = 'ServiceItemSettingHist';
@Injectable()
export class ServiceItemHistoryDataService extends EfaactDataService<ServiceItemHistory> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
        log.verbose({
            type: `${entityName}DataService`,
            msg: '::'
        });
        this.usePostForQuery = true;
    }
    mapItems(item: ServiceItemHistory): ServiceItemHistory {
        return {
            ...item,
            id: `${
                item.SIListID
            }-${item.SessionStart.valueOf()}-${item.SessionEnd.valueOf()}`
        };
    }
}
